import vpcApiRequest from '../../service/eip/request';
import whiteList from '../../service/common/whiteList';
import getregionChina from '../../service/common/getregionChina';
import { releaseConfig } from "../../service/common/initEdition";
import * as _ from 'lodash'

import {Mixins, Component, Watch, Vue} from 'vue-property-decorator'

// import Vue from 'vue'

function getType(str:any) {
    let type = str.match(/(vpc)|(bws)|(dc)|(vpn)|(kcm)|(pdns)/);
    const lbacl = str.indexOf('slb/acl');
    const vpcacl = str.indexOf('vpc/acl');
    const evif = str.indexOf('evif');
    if (vpcacl != -1) {
        return 'acl';
    } else if (lbacl != -1) {
        return "lbAcl";
    } else if (evif !== -1) {
        return 'evif'
    }

    if (str.indexOf('vpc/connect') !== -1) {
        return 'peer';
    }

    if (type) {
        type = type[0];
    }
    return type;
}

@Component
export default class NetworkIndex extends Vue {
    currency = {
        code: 'CNY',
        name: '元',
        symbol: '¥'
    }
    isShowData = false
    specialUser = false
    showRegions = true
    routeInitDone = false
    allRegions = []
    curRegion:any = null
    curRegionDetail:any = null
    region:any = null
    vpcRegions:any = []
    vpcRegionsOther = []
    basicRegions = []
    isMore = ''
    currentBasicRegion = null
    getregionChina = getregionChina
    vpcInfoLoading = true
    allotList = []
    currentAllot = {}
    allotListAll = []
    allotTimer = null

    get regionAvailable():any {
        const me:any = this;
        if (!me.region) {
            return true;
        }
        let type = getType(me.$route.path);
        return whiteList.check(type, me.region);
    }
    get needProject():boolean {
        return _.get(this, '$route.meta.needProject', false);
        // const me:any = this;
        // let str = me.$route.path;
        // const eip = str.indexOf('eipIndex');
        // const bws = str.indexOf('bwsIndex');
        // const slb = str.indexOf('slbIndex');
        // const vpn = str.indexOf('vpnsub');
        // const pdns = str.indexOf('pdns');
        // if ((eip != -1 || bws != -1 || slb != -1 || vpn != -1 || pdns != -1) && whiteList.isVpc(me.region)) {
        //     return true
        // } else {
        //     return false
        // }
    }
    get isSeas () {
        return window.KSC_SECNET_CONSOLE.BASE_HOST === 'console.'+ releaseConfig.domain
    }
    get isEmbedded () {
        return window.KSC_SECNET_CONSOLE.BASE_HOST === 'embedded.'+ releaseConfig.domain
    }

    clickRegion(region:any) {
        const me:any = this;
        me.region = region.code;
        me.curRegionDetail = _.find(me.allRegions, ['code', me.region]);

        me.$root.setRegion(region.code);
        if (whiteList.isVpc(me.region)) {
            me.currentBasicRegion = null
        }
        const cur = _.find(me.vpcRegionsOther, ['code', me.region]);

        if (!whiteList.isVpc(me.region) || cur) {
            _.forEach(me.allRegions, function (item) {
                if (item.code == me.region) {
                    me.currentBasicRegion = item;
                }
            })
        }
    }
    changeAllot(item:any) {
        const me:any = this;
        localStorage.allotId = item.ProjectId;
        me.currentAllot = {
            "allotId": item.ProjectId,
            "allotName": item.ProjectName
        }
    }


    async getRegion() {
        return new Promise((resolve, reject) => {

        })
    }

    getRegionDetail() {
        var me:any = this;
        console.log('getRegionDetail')
        return new Promise((resolve, reject) => {
            me.$root.loadRegion().then((regionData:any) => {
                me.routeInitDone = true;
                _.forEach(regionData, (v, k) => {
                    me[k] = v;
                });
                me.region = me.curRegion;
                me.queryPriceCb && me.queryPriceCb(_.get(regionData, 'queryPriceData'));

                //一刷新就判断是不是basic机房 如果是下拉框里的别选中
                var cur = _.find(me.vpcRegionsOther, ['code', me.region]);
                if (!whiteList.isVpc(me.region) || cur) {
                    _.forEach(me.allRegions, function (item) {
                        if (item.code == me.region) {
                            me.currentBasicRegion = item
                        }
                    })
                }

                if (me.needProject) {
                    me.allotTimer && clearTimeout(me.allotTimer);
                    me.allotTimer = setTimeout(() => {
                        me.allotListAll = [];
                        me.allotList = [];
                        vpcApiRequest.getAllotDataNew({
                            Region: me.region
                        }).done(function (data:any) {
                            me.vpcInfoLoading = false;
                            if (!data || data.ListProjectResult.ProjectList.length == 0) {
                                me.allotList = [{
                                    ProjectName: '无任何项目',
                                    ProjectId: "noProject"
                                }];
                                me.currentAllot = {
                                    allotName: '无任何项目',
                                    allotId: "noProject"
                                }
                                localStorage.allotId = me.allotList[0].ProjectId;
                                console.log(44444555555)
                                resolve(data);
                                return;
                            }

                            var arrOptions:any = [];
                            var arrIds:any = [];
                            _.forEach(data.ListProjectResult.ProjectList, (item) => {
                                arrIds.push(item.ProjectId)
                                arrOptions.push({
                                    ProjectName: item.ProjectName,
                                    ProjectId: item.ProjectId
                                })
                            })
                            arrOptions.sort((a:any, b:any) => {
                                return a.ProjectId - b.ProjectId;
                            })
                            me.allotListAll = arrIds;
                            me.allotList = arrOptions;
                            var currentAllot:any = {};

                            me.allotList.unshift({
                                ProjectName: me.$trans(`全部项目`),
                                ProjectId: "AllotAll"
                            });

                            if (!localStorage.allotId) {
                                localStorage.allotId = me.allotList[0].ProjectId;
                                currentAllot.allotId = me.allotList[0].ProjectId;
                                currentAllot.allotName = me.allotList[0].ProjectName;
                            } else {
                                currentAllot.allotId = localStorage.allotId;
                                let hasIt = false;
                                _.forEach(me.allotList, function (item) {
                                    if (item.ProjectId == currentAllot.allotId) {
                                        hasIt = true;
                                        currentAllot.allotName = item.ProjectName;
                                    }
                                });
                                if (!hasIt) {
                                    localStorage.allotId = me.allotList[0].ProjectId
                                    currentAllot.allotId = me.allotList[0].ProjectId
                                    currentAllot.allotName = me.allotList[0].ProjectName;
                                }
                            }
                            me.currentAllot = currentAllot;
                            console.log(5666661)
                            resolve(data);
                        })
                    }, 200)
                } else {
                    resolve(undefined);
                }
            }).catch(() => {
                me.routeInitDone = true;
                reject();
            });
        });
    }

    mounted() {
        const me:any = this;
        window.__ksStorage__.getBaseInfo('userInfo', function (userData:any) {
            me.specialUser = false;
            me.currency = userData.user.currency || {
                code: 'CNY',
                name: '元',
                symbol: '¥'
            };
        });

        // $('.network-header').on('mouseover', '.home-more', function () {
        //     $(this).addClass('click');
        // }).on('mouseout', '.home-more', function () {
        //     $(this).removeClass('click');
        // })
        //
        // $('.network-header').on('mouseover', '.more', function () {
        //     $(this).addClass('hover');
        // }).on('mouseout', '.more', function () {
        //     $(this).removeClass('hover');
        // })
    }
    destroyed() {
        // $('.network-header').off('mouseover', '.home-more').off('mouseout', '.home-more');
    }
};
